import { render, staticRenderFns } from "./LoginSetNewPassword.vue?vue&type=template&id=62c22174"
import script from "./LoginSetNewPassword.vue?vue&type=script&lang=js"
export * from "./LoginSetNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports